export enum QuestionType {
    Text = "Text",
    Int = "Int",
    Date = "Date",
    MultiSelect = "MultiSelect",
    Radio = "Radio",
    Scale = "Scale"
}